import { createFeatureSelector } from '@ngrx/store';
import { AuthState } from './auth.state';

export const authKey = 'auth';
export const getAuthState = createFeatureSelector<AuthState>(authKey);
